import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-shell">
        <div className="row primary">

          <div className="column links">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="/contact">Support</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
              <li>
                <a href="https://status.flinthost.com/">Status</a>
              </li>
              <li>
                <a href="/hardware">Hardware by Location</a>
              </li>
            </ul>
          </div>

          <div className="column links">
            <h4>Company</h4>
            <ul>
              <li>
                <a href="/partnerships">Partners</a>
              </li>
              <li>
                <a href="/affiliates">Affiliates</a>
              </li>
            </ul>
          </div>

          <div className="column links legal-column">
            <h4>Legal</h4>
            <ul>
              <li>
                <a href="/tos">Terms of Service</a>
              </li>
              <li>
                <a href="/privacy">Privacy Policy</a>
              </li>
              <li>
                <a href="/acceptable-use">Acceptable Use</a>
              </li>
              <li>
                <a href="/refunds">Refund Policy</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="copyright">
          <p>Copyright 2026 © FlintHost. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
